import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { money } from './QuantityStepper';
import { builderPrices, builderAssets } from '../data/builder';
import { careKitConnected } from '../utils/cartAddons';
interface CareKitControlProps {
  value: number;
  max: number;
  onChange: (next: number) => void;
  className?: string;
}

/**
 * Anti-Fog Care Kit add-on for the Complete System and every multipack.
 * Starts at 0 and never follows the pack size. Hidden if the Care Kit product isn't connected.
 */
export function CareKitControl({
  value,
  max,
  onChange,
  className = ''
}: CareKitControlProps) {
  if (!careKitConnected()) return null;
  const clamped = Math.min(value, max);
  return <div className={`border border-grit-500/30 bg-grit-500/[0.06] p-3.5 ${className}`} data-id="element-390" data-mp="2ubigr9wu0gdc">
      <div className="flex items-center justify-between gap-3" data-id="element-391" data-mp="xigot4gggz3q">
        <p className="flex min-w-0 items-center gap-2.5" data-id="element-392" data-mp="xgmesl6q2ref">
          <img src={builderAssets.careKit} alt="" loading="lazy" className="h-9 w-9 shrink-0 bg-ink-950 object-contain" data-id="element-393" data-mp="sknk6fuswd5k" />
          <span className="min-w-0" data-id="element-394" data-mp="2jbliowskr086">
            <span className="block text-[13px] font-bold uppercase leading-tight tracking-wide text-offwhite" data-id="element-395" data-mp="2jcn7e42ijl8d">
              {max > 1 ? 'Add anti-fog care kits?' : 'Add the anti-fog care kit?'}
            </span>
            <span className="block text-[12px] text-steel-400" data-id="element-396" data-mp="2aannn404631q">
              +{money(builderPrices.careKit)} each · anti-fog cleaner + microfiber
            </span>
          </span>
        </p>
        <div className="flex shrink-0 items-center border border-white/15" data-id="element-397" data-mp="32y9qub5fj5o2">
          <button type="button" aria-label="Remove one care kit" disabled={clamped <= 0} onClick={() => onChange(clamped - 1)} className="flex h-9 w-9 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-grit-500" data-id="element-398" data-mp="2o954qivikhao">
            <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-399" data-mp="3vjgh6jkvvbgl" />
          </button>
          <span aria-live="polite" className="w-8 text-center font-display text-lg font-extrabold tabular-nums text-offwhite" data-id="element-400" data-mp="3qn9bmrweg1z6">
            {clamped}
          </span>
          <button type="button" aria-label="Add one care kit" disabled={clamped >= max} onClick={() => onChange(clamped + 1)} className="flex h-9 w-9 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-grit-500" data-id="element-401" data-mp="3hmjmg71n99uf">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-402" data-mp="2xzlujmuc7tha" />
          </button>
        </div>
      </div>
      {clamped > 0 && <p className="mt-2 text-right text-[12px] font-semibold text-grit-500" data-id="element-403" data-mp="2ox4btidw5iz1">
          + {money(clamped * builderPrices.careKit)} at checkout
        </p>}
    </div>;
}